import Vue from 'vue';
import {
  ROLE_QA_EXPERT,
  ROLE_PROOF_READER,
  ROLE_PROJECT_MNG,
  ROLE_SYSTEM_ADMIN,
} from '@/utils/const';

import Api from '@/utils/api';

import Multiselect from 'vue-multiselect';
import popupInfo from './popupInfo/index.vue';

import errorComments from '@/components/errorComments/index.vue';

export default Vue.extend({
  name: 'errorIntellegenceItem',
  props: {
    error: {
      type: Object,
      default: () => {},
    },
    showMoreBlock: {
      type: Boolean,
      default: false,
    },
    filter: {
      type: Object,
      default: () => {},
    },
  },
  components: {
    errorComments,
    Multiselect,
    popupInfo,
    'editable-cell': () => import('./editableField/index.vue'),
    'tool-tip': () => import('@/components/tooltip/index.vue'),
  },
  data() {
    return {
      commentData: [],
      comment: '',
      showNote: false,
      defaultErrorCategoryID: {},
      defaultSeverity: {},
      defaultMetaruleID: {},
      formatData: {
        ErrorCategoryID: null,
        Severity: null,
        MetaruleID: null,
      },
      showErrorInfo: false,

      filterParams: {
        name: 'errors_intelligence?',
        url: '',
      },
      popupTop: false,
      showInfoProject: false,

    };
  },
  created() {
    this.createDefaultSelects();
  },
  methods: {
    checkRole() {
      if (this.$store.getters.userRole === ROLE_SYSTEM_ADMIN ||
        this.$store.getters.userRole === ROLE_QA_EXPERT ||
        this.$store.getters.userRole === ROLE_PROOF_READER ||
        this.$store.getters.userRole === ROLE_PROJECT_MNG) {
        return true;
      }
      return false;
    },
    removeComment() {
      this.error.HasComments = false;
      this.error.Notes--;
      if (Array.isArray(this.error.Commentators)) {
        this.error.Commentators = this.error.Commentators.filter((item) => item !== this.user.UserId);
      } else {
        this.error.Commentators = [];
      }
    },
    addComment() {
      this.error.HasComments = true;
      this.error.Notes++;
      this.error.Commentators = [];
      this.error.Commentators.push(this.user.UserId);
    },
    getPropertyData(id, type) {
      switch (type) {
      case 'category':
        if (this.filter.errorCategoryList.find((item) => item.ID === id) !== undefined) {
          return this.filter.errorCategoryList.find((item) => item.ID === id).Name;
        }
        break;
      case 'severity':
        if (this.filter.errorSeverityList.find((item) => item.ID === id) !== undefined) {
          return this.filter.errorSeverityList.find((item) => item.ID === id).Name;
        }
        break;
      case 'metarule':
        if (this.filter.metarulesList.find((item) => item.ID === id) !== undefined) {
          return this.filter.metarulesList.find((item) => item.ID === id).Name;
        }
        break;
      case 'err-desc':
        const errItem = this.filter.errorCategoryList.find((item) => item.ID === id);
        return errItem ? errItem.Description : '';
      default:
        break;
      }
    },
    /**
     * Show popup
     */
    holderDeleteErrorItem() {
      this.$modal.show('dialog', {
        title: 'Warning!',
        text: 'Are you sure you`d lite delete this error item?',
        buttons: [{
          title: 'Yes',
          handler: () => {
            this.deleteErrorItem();
            this.$modal.hide('dialog');
          },
        },
        {
          title: 'No',
        },
        ],
      });
    },

    /**
     * Remove error item
     */
    deleteErrorItem() {
      Api.reports
        .deleteError(this.error.ID)
        .then((data) => {
          if (data.data.Status) {
            this.$root.$emit('notification', {
              message: 'Remove successful',
              type: 'info',
              show: true,
            });

            this.$emit('removeErrorItem', this.error.ID, data.data.SampleValue.Rating);
          } else {
            this.$root.$emit('notification', {
              message: data.data.Message,
              type: 'error',
              show: true,
            });
          }
        });
    },

    createDefaultSelects() {
      this.defaultErrorCategoryID = {};
      this.defaultSeverity = {};
      this.defaultMetaruleID = {};

      this.filter.errorCategoryList.forEach((item) => {
        if (this.error.ErrorCategoryID === item.ID) {
          this.defaultErrorCategoryID = {
            'ID': item.ID,
            'Name': item.Name,
          };
        }
      });

      this.filter.metarulesList.forEach((item) => {
        if (this.error.MetaruleID === item.ID) {
          this.defaultMetaruleID = {
            'ID': item.ID,
            'Name': item.Name,
          };
        }
      });

      this.filter.errorSeverityList.forEach((item) => {
        if (this.error.Severity === item.ID) {
          this.defaultSeverity = {
            'id': item.ID,
            'Name': item.Name,
          };
        }
      });
    },
    changeErrorType(value, id, type) {
      if (this.error.ID == id) {
        this.formatData[type] = value.ID;
      }
    },
    updateItem() {
      Object.keys(this.formatData).forEach((key) => {
        const value = this.formatData[key];
        if (value) {
          this.error[key] = value;
        }
      });
      Api.reports
        .updateErrorItem(this.error)
        .then((data) => {
          if (data.data.Status) {
            this.$emit('updateErrorItem', {
              rating: data.data.Data.Rating,
              ko: data.data.Data.KOStatus,
              type: data.data.Data.ReportType,
              metarules: data.data.Data.UsedMetarules,
            });

            this.$root.$emit('notification', {
              message: 'Update successful!',
              type: 'info',
              show: true,
            });
          } else {
            this.$root.$emit('notification', {
              message: data.data.SystemMessage,
              type: 'error',
              show: true,
            });
          }
        });
    },
  },
  removeComment() {
    this.error.HasComments = false;
    this.error.Notes--;
    if (Array.isArray(this.error.Commentators)) {
      this.error.Commentators = this.error.Commentators.filter((item) => item !== this.user.UserId);
    } else {
      this.error.Commentators = [];
    }
  },
  addComment() {
    this.error.HasComments = true;
    this.error.Notes++;
    this.error.Commentators = [];
    this.error.Commentators.push(this.user.UserId);
  },
  getErrorDescription(errorId) {

  },
});
